import { Text } from '@/ui-kit'
import { AlertTriangle } from 'lucide-react'
import type { TaskRendererProps } from './task-types'

export function UnsupportedTaskFallback({ task }: Pick<TaskRendererProps, 'task'>) {
  return (
    <div className="flex flex-col items-center gap-4 rounded-2xl border border-solid border-gray-100 p-6 text-center">
      <AlertTriangle size={32} className="text-gray-80" />
      <div className="flex flex-col gap-1">
        <Text type="subtitle-semibold">Unsupported task type</Text>
        <Text type="body2-regular" className="text-gray-80">
          This task requires type{' '}
          <code className="rounded bg-gray-100 px-1.5 py-0.5 font-mono text-xs">{task.type}</code>{' '}
          which is not yet supported.
        </Text>
      </div>
    </div>
  )
}
